import React from 'react'
import { Spinner } from './Spinner'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  variant?: 'default' | 'icon'
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className,
  variant = 'icon'
}) => {
  return (
    <Spinner 
      size={size} 
      className={className} 
      variant={variant}
    />
  )
}
